import React from "react";
import { useTranslation } from "react-i18next";
import { FORM_NAME } from "src/constant/common";

const ModalViewEnvironment = ({ simulationData }) => {
  const { t } = useTranslation("gnc-simulator-6dof");

  const environmentProperties = [
    { key: "wind_speed", label: t(`new.environment.${FORM_NAME.ENVIRONMENT.WIND_SPEED}`) },
    { key: "wind_direction", label: t(`new.environment.${FORM_NAME.ENVIRONMENT.WIND_DIRECTION}`) },
    { key: "air_density", label: t(`new.environment.${FORM_NAME.ENVIRONMENT.AIR_DENSITY}`), unit: <>kg/m&sup3;</> },
    { key: "gravity", label: t(`new.environment.${FORM_NAME.ENVIRONMENT.GRAVITY}`), unit: <>m/s&sup2;</> },
    { key: "atmospheric_pressure", label: t(`new.environment.${FORM_NAME.ENVIRONMENT.ATMOSPHERIC_PRESSURE}`) },
  ];
  const environmentObj = simulationData?.input_data?.environment;
  return (
    <div className="m-3">
      {environmentObj &&
        environmentProperties.map(({ key, label, unit }) => (
          <div className="fw-bold mb-3" key={key}>
            <span>{label}</span>
            <span> ({unit || environmentObj?.[key]?.unit}) = </span>
            <span>{environmentObj?.[key]?.value}</span>
          </div>
        ))}
    </div>
  );
};

export default ModalViewEnvironment;
